import type { AccountsReceivablesFormSchema, AccountsReceivablesQuerySchema } from './schemas';

export function accountsReceivablesQueryToForm(data: AccountsReceivablesQuerySchema): AccountsReceivablesFormSchema {
  return {
    ...data,
    amount_original: data?.amount_original ?? 0,
    balance_due: data?.balance_due ?? 0,
    total_paid: data?.total_paid ?? 0,
  };
}
